module.exports = __webpack_public_path__ + "static/media/gca_1.704de6fb.png";